import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'

import { BaseComponent } from '../../shared'
import { PurchasingQuote } from '../../shared/data-models'

@Component({
    selector: 'app-purchasing-quoting',
    templateUrl: './purchasing-quoting.component.html',
    standalone: true,
    imports: [CommonModule],
})
export class PurchasingQuotingComponent extends BaseComponent implements OnInit {
    public quotes: PurchasingQuote[] = []

    constructor() {
        super()
        this.isInitialLoading = false
    }

    ngOnInit(): void {
        this.services.data.http.get<PurchasingQuote[]>('/api/PurchasingQuote').subscribe({
            next: result => (this.quotes = result || []),
            error: () => this.services.notification.error('Failed to load quotes'),
        })
    }
}
